export default "__VITE_ASSET__BmCTdURi__"